import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ExtendedCardType, CardType } from '@/models/payment';
import util from '@/Utils/util';

export const fetchPaymentSources = async ({
  userId,
  isGetDistanceFromHomeAddress,
}: {
  userId: string;
  isGetDistanceFromHomeAddress?: boolean;
}): Promise<ExtendedCardType[]> => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      userId,
      isGetDistanceFromHomeAddress,
    },
    query: graphql(`
      query PaymentSources($userId: String!, $isGetDistanceFromHomeAddress: Boolean) {
        paymentSources(userId: $userId, isGetDistanceFromHomeAddress: $isGetDistanceFromHomeAddress) {
          id
          object
          address_city
          address_country
          address_line1
          address_line1_check
          address_line2
          address_state
          address_zip
          address_zip_check
          brand
          country
          customer
          exp_month
          exp_year
          fingerprint
          funding
          last4
          name
          is_default
          metadata
          email
          phone
          notes
          cvc_check
          distanceFromHomeAddressInMiles
          isDirectExpress
        }
      }
    `),
  });

  const paymentSources = response.data?.paymentSources?.map((item: CardType) => util.formatCreditCardInfo(item)) ?? [];

  return paymentSources;
};
